import type { SVGProps } from "react";

export const MFAWebAuthnRoamingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 6.5L1.5 14.5L14.5 14.5L14.5 6.5L1.5 6.5ZM1 5C0.447715 5 0 5.44771 0 6L0 15C0 15.5523 0.447715 16 1 16H15C15.5523 16 16 15.5523 16 15V13.3333H16.5L19 13.3333C19.5523 13.3333 20 12.8856 20 12.3333V8.5C20 7.94772 19.5523 7.5 19 7.5L16.5 7.5H16V6C16 5.44772 15.5523 5 15 5L1 5ZM18.5 9H16.5V11.8333H18.5V9ZM9.28459 11.5C9.92892 11.5 10.4513 10.9776 10.4513 10.3333C10.4513 9.68896 9.92892 9.16663 9.28459 9.16663C8.64025 9.16663 8.11792 9.68896 8.11792 10.3333C8.11792 10.9776 8.64025 11.5 9.28459 11.5ZM9.28459 13C10.7573 13 11.9513 11.8061 11.9513 10.3333C11.9513 8.86053 10.7573 7.66663 9.28459 7.66663C7.81183 7.66663 6.61792 8.86053 6.61792 10.3333C6.61792 11.8061 7.81183 13 9.28459 13ZM3.95125 10.3333C3.95125 10.7015 3.65278 11 3.28459 11C2.9164 11 2.61792 10.7015 2.61792 10.3333C2.61792 9.9651 2.9164 9.66663 3.28459 9.66663C3.65278 9.66663 3.95125 9.9651 3.95125 10.3333Z"
      fill="#757575"
    />
  </svg>
);
